import { LoadingModalProps } from './loading-modal.component';

interface ViewProps {}

const useLoadingModal = (props: LoadingModalProps): ViewProps => {
    // Controller logic can be added here if needed in the future
    return {};
};

export default useLoadingModal;
